export const routes = {
    // home: "/",
    lobby: "/lobby",
    deviceCheck: "/devicecheck/:id",
    room: "/room/:roomId",
    invalid: "/invalid",
    notFound: "/notfound",
}